import { useContext } from "react";
import {
  NotFoundPage,
  ModalProvider,
  ModalContext,
  UpgradeSubscriptionModalType,
  DropdownOptions,
  TooltipPopup,
  useCheckIfSubscriptionFeatureActiveBroker,
  Button,
  Flex,
} from "dash-ui";
import { useNavigate } from "react-router-dom";
import { ServerErrors } from "dash-common";

import { useGetPropertyByIdQuery } from "gql/generated.graphql";

import { RoutesPath } from "flow-components/routes/routes";
import Header from "flow-components/Header/Header";
import Container from "flow-components/Container/Container";
import PropertyPreview from "containers/properties/PropertyPreview/PropertyPreview";
import AddPropertyToPortfolioModal from "containers/portfolio/AddPorpertyToPortfolioModal/AddPropertyToPortfolioModal";
import UpgradeSubscriptionModal from "common/components/UpgradeSubscriptionModal/UpgradeSubscriptionModal";
import {
  PropertyPreviewParamsContext,
  PropertyPreviewParamsProvider,
} from "containers/properties/PropertyPreview/context/PropertyPreviewParamsContext";

import PropertyPreviewSidebar from "./components/PropertyPreviewSidebar/PropertyPreviewSidebar";
import UnavailableProperty from "./components/UnavailableProperty/UnavailableProperty";
import { SubscriptionChangeConfirmationModal } from "pages/ProfilePage/components/ProfileBilling/components";
import LimitedAccessBanner from "../PropertiesPage/components/LimitedAccessBanner";
import { isPropertyAccessFree } from "common/helpers";

function PropertyPreviewPage() {
  const { isSubscriptionActive } = useCheckIfSubscriptionFeatureActiveBroker();

  const { params } = useContext(PropertyPreviewParamsContext);
  const shouldHideProperty =
    !isSubscriptionActive && !isPropertyAccessFree(params.propertyId || "");

  const { data, loading, error } = useGetPropertyByIdQuery({
    variables: { propertyId: params.propertyId },
    skip: shouldHideProperty,
  });
  const property = data?.getPropertyById;
  const navigate = useNavigate();
  const { upgradeSubscriptionModal } = useContext(ModalContext);

  if (shouldHideProperty) {
    return (
      <>
        <Header />
        <Container
          breadcrumbsProps={{ sticky: true }}
          withSidebar
          showContent
          className="bg-[#F8FBFD]"
        >
          <Flex
            alignItems="center"
            justifyContent="center"
            w={"100%"}
            flexDirection="column"
          >
            <LimitedAccessBanner propertyDetailsLimitMessage={true} />
            <Button
              h={40}
              minWidth={153}
              onClick={() => navigate(RoutesPath.Properties)}
            >
              Go back to Properties
            </Button>
          </Flex>
        </Container>
        <UpgradeSubscriptionModal
          type={UpgradeSubscriptionModalType.COMPLETE_ACCOUNT}
        />
      </>
    );
  }

  if (error?.message === ServerErrors.PORTFOLIO_NOT_AVAILABLE && !loading) {
    return (
      <>
        <Header />
        <Container breadcrumbsProps={{ sticky: true }} withSidebar>
          <UnavailableProperty />
        </Container>
      </>
    );
  }
  if (!property && !loading) {
    return <NotFoundPage onRedirect={() => navigate(RoutesPath.Properties)} />;
  }

  return (
    <>
      <Header />
      <DropdownOptions />
      <TooltipPopup />
      <AddPropertyToPortfolioModal />
      <PropertyPreview
        property={property}
        loading={loading}
        leftSideBar={<PropertyPreviewSidebar property={property!} />}
      />
      <SubscriptionChangeConfirmationModal />
      <UpgradeSubscriptionModal type={upgradeSubscriptionModal?.type} />
    </>
  );
}

const Wrapper = () => (
  <PropertyPreviewParamsProvider>
    <ModalProvider>
      <PropertyPreviewPage />
    </ModalProvider>
  </PropertyPreviewParamsProvider>
);
export default Wrapper;
